import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";

export const SpeakerLeaveButton = () => {
  const [t] = useTranslation(["podium"], translationHookOptions);

  return (
    <>
      <Link to={`../podium`}>
        <Button
          id="btnLeaveMeeting"
          color=""
          className="navbarButton navbarButtonEnabled mr-2"
        >
          <span className="font-size-80 font-weight-bold mr-2 d-none d-lg-inline-block">
            {t("speaker_leave_button")}
          </span>
          <i className={"fas fa-sign-out-alt align-middle fa-lg"}></i>
        </Button>
      </Link>
    </>
  );
};
